import { render } from "./CIS-Resource-White-Paper.vue?vue&type=template&id=728891d8&scoped=true"
import script from "./CIS-Resource-White-Paper.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-White-Paper.vue?vue&type=script&lang=js"

import "./CIS-Resource-White-Paper.vue?vue&type=style&index=0&id=728891d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728891d8"]])

export default __exports__